import { useEffect, useState } from "react";
import { ThemeBtnContainer } from "./styles";


const ThemeButton = () => {

  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const savedTheme = document?.documentElement?.getAttribute('data-theme') || 'light';
    setTheme(savedTheme);
  }, []);

  const handleThemeChange = (theme) => {
    setTheme(theme);
    localStorage.setItem('theme', theme);
    document.documentElement.setAttribute('data-theme', theme);

  };

  return (
    <ThemeBtnContainer 
      onClick={() => handleThemeChange(theme === 'light' ? 'dark' : 'light')}
    >
      <span className="theme-txt">Modo Día/Noche</span>
      <button 
        className="theme-btn" 
        aria-label={`Cambiar a modo ${theme === 'light' ? 'noche' : 'día'}`}
      >
        <div className="icon light"></div>
        <div className="icon dark"></div>
        <span className={`slider ${theme}`}></span>
      </button>
    </ThemeBtnContainer>
  )
}

export default ThemeButton